export default {
  PageTitle: 'Coming Soon',
  MarketingTitle: 'Coming Soon from Texas.gov!',
  MarketingSubtitle:
    'We’re making state business easier, faster, and more secure for all Texans.',
  MarketingContent: ` <p>While we have big plans for the near future, we're starting with a release for the Texas Department of
  Licensing and Regulation to make renewing professional licenses simpler and more efficient.</p><p>Please check back soon for more information.</p>`,
};
